// English translations for the dashboard page (French string -> English).
const m: Record<string, string> = {
  // Page chrome
  'Tableau de bord': 'Dashboard',
  'Vue d’ensemble de votre activité Storiz': 'Overview of your Storiz activity',
  '{n} commandes': '{n} orders',

  // Section headings
  'Trésorerie': 'Cash position',
  'vs période précédente': 'vs previous period',
  'Pipeline': 'Pipeline',
  'Actions requises': 'Required actions',
  'Livraisons AMEEX': 'AMEEX deliveries',
  'Performance opérationnelle': 'Operational performance',
  'Performance par ville': 'Performance by city',
  'Insights': 'Insights',

  // Cash KPIs
  'Encaissé': 'Collected',
  '{n} colis livrés': '{n} parcels delivered',
  'En route': 'In transit',
  '{n} colis en transit': '{n} parcels in transit',
  'Perdu (retours + refus)': 'Lost (returns + refusals)',
  '{n} colis': '{n} parcels',
  'taux': 'rate',
  'Bénéfice net': 'Net profit',
  'Coût': 'Cost',
  'marge': 'margin',

  // Pipeline funnel
  'En attente album': 'Awaiting album',
  'Client n’a pas soumis': 'Customer hasn’t submitted',
  'À valider (+ en revue)': 'To validate (+ in review)',
  'En production / Imprimé': 'In production / Printed',
  'En fab. ou prêt à expédier': 'In production or ready to ship',
  'En route via AMEEX': 'On the way via AMEEX',
  'Cash encaissé': 'Cash collected',

  // Action tiles
  'Clients à relancer': 'Customers to follow up',
  '+ de 7 jours sans soumission': 'More than 7 days without submission',
  'Albums à valider': 'Albums to validate',
  'Soumis, en attente': 'Submitted, pending',
  'Prêts à expédier': 'Ready to ship',
  'Imprimés, sans colis AMEEX': 'Printed, no AMEEX parcel',
  'Colis bloqués': 'Stuck parcels',
  'Pas de mouvement +5j': 'No movement for 5+ days',
  'Couvertures manquantes': 'Missing covers',
  'Recherchées, sans design': 'Searched, no design',

  // Action list rows
  'couverture manquante': 'missing cover',
  'Recherchée par {c} clients · {n} recherches': 'Searched by {c} customers · {n} searches',
  'Couverture ajoutée — prévenir': 'Cover added — notify',
  'Client inconnu': 'Unknown customer',
  '{n}j sans soumission': '{n}d without submission',
  'Pas de téléphone': 'No phone number',
  'Bonjour {name} 👋, c’est Storiz. On a remarqué que votre album n’est pas encore finalisé depuis {n} jours. Avez-vous besoin d’aide pour le compléter ? On reste à votre disposition !': 'Hi {name} 👋, this is Storiz. We noticed your album hasn’t been finalized for {n} days. Do you need any help completing it? We’re here for you!',
  'album soumis': 'album submitted',
  'prêt à expédier': 'ready to ship',
  'colis bloqué {n}j': 'parcel stuck for {n}d',
  'statut': 'status',
  'Envoyer un message de relance': 'Send a follow-up message',
  'Ouvrir WhatsApp': 'Open WhatsApp',

  // Operational KPIs
  'Taux de livraison': 'Delivery rate',
  'Aucun colis terminé': 'No completed parcels',
  '{d} livrés sur {total}': '{d} delivered out of {total}',
  'Délai moyen de livraison': 'Average delivery time',
  'De la commande à la livraison': 'From order to delivery',
  'Clients fidèles': 'Repeat customers',
  'Aucune commande répétée': 'No repeat orders',
  'Ont commandé +1 fois': 'Ordered more than once',

  // City health
  'Top {n} villes par volume · données AMEEX directes': 'Top {n} cities by volume · direct AMEEX data',
  '{total} colis · {d} livrés': '{total} parcels · {d} delivered',
  '{n} en route': '{n} on the way',
  '{n} perdus': '{n} lost',
  'Taux de livraison (livrés / colis terminés)': 'Delivery rate (delivered / completed parcels)',

  // Insights / sparkline
  'Pas encore de commandes sur cette période.': 'No orders yet for this period.',
  'Activité': 'Activity',
  'Commandes par jour': 'Orders per day',
  'Commandes payées par jour': 'Paid orders per day',
  'Cumulé': 'Total',
  'cmd': 'orders',

  // Top clients
  'Meilleurs clients': 'Top customers',
  '{n} livrés': '{n} delivered',
  '{n} en cours': '{n} in progress',

  // Traffic sources
  'Sources de trafic': 'Traffic sources',

  // Latest submitted card
  'Dernier album soumis': 'Latest submitted album',
  'Aucun album soumis pour le moment.': 'No album submitted yet.',
  'à l’instant': 'just now',
  'il y a {n} min': '{n} min ago',
  'il y a {n} h': '{n} h ago',
  'il y a {n} j': '{n} d ago',
  'en direct': 'live',
  '{n} papier': '{n} paper',

  // Recent orders table
  'Commandes récentes': 'Recent orders',
  'Voir toutes': 'View all',
  'Commande': 'Order',
  'Formule': 'Bundle',
  'Aucune commande récente': 'No recent orders',

  // Missing-cover notify modal
  'Couverture': 'Cover',
  'Sélectionnez la couverture que vous venez d’ajouter pour « {dest} ». Elle sera épinglée en tête du choix de couverture pour ces clients.': 'Select the cover you just added for “{dest}”. It will be pinned at the top of the cover selection for these customers.',
  '— Choisir une couverture —': '— Choose a cover —',
  '(masquée)': '(hidden)',
  'Mise à jour…': 'Updating…',
  'Couverture ajoutée — prévenir les clients': 'Cover added — notify customers',
  '✅ Couverture épinglée pour {n} commandes. Prévenez chaque client :': '✅ Cover pinned for {n} orders. Notify each customer:',
  'Aucun client avec une commande rattachée à prévenir.': 'No customer with a linked order to notify.',
  'Renvoyer': 'Resend',
  'Impossible de charger les couvertures.': 'Unable to load covers.',
  'Échec de la mise à jour.': 'Update failed.',

  // KPI card
  'Variation vs période précédente': 'Change vs previous period',
  // WhatsApp funnel card (2026-10-10).
  'Entonnoir WhatsApp': 'WhatsApp funnel',
  'Ont écrit sur WhatsApp': 'Wrote on WhatsApp',
  'Ont envoyé leurs photos': 'Sent their photos',
  'Ont approuvé l’aperçu 3D': 'Approved the 3D preview',
  'Commande confirmée': 'Order confirmed',
  'Entonnoir WhatsApp par semaine': 'WhatsApp funnel by week',
  'Semaine du {d}': 'Week of {d}',
  'règle photos/argent': 'photos/money rule',
  '% = sur les personnes qui ont écrit dans la période (par semaine de leur premier message).': '% = of the people who wrote in the period (by the week of their first message).',
  '{n} commandes archivées (ni photos ni argent) ne comptent pas — ces personnes restent dans « ont écrit ».': '{n} archived orders (no photos, no money) are not counted — those people stay in « wrote ».',
  'Règle « commande = photos ou argent » activée le {d}.': '« Order = photos or money » rule switched on {d}.',
  'Règle « commande = photos ou argent » : pas encore activée.': '« Order = photos or money » rule: not switched on yet.',
  'Ancien calcul — un seul taux (commandes du site + WhatsApp)': 'Old calculation — one rate (site + WhatsApp orders)',
  // « Qui nous attend » — who is waiting on us (2026-10-10, fix 4).
  'Qui nous attend': 'Waiting on us',
  'Personne n’attend après nous.': 'Nobody is waiting on us.',
  '{n} photos, pas d’aperçu': '{n} photos, no preview',
  'attend une personne': 'waiting for a person',
  'Cliente': 'Client',
  'depuis {n} min': '{n} min',
  'depuis {n} h': '{n} h',
  'depuis {n} j': '{n} d',
};
export default m;
